// core/DomReaper.ts
class DomReaper {
    static ensureObserver() {
        if (this.observer)
            return;
        const stillInDom = (n) => n.isConnected || document.contains(n);
        this.observer = new MutationObserver((mutations) => {
            for (const m of mutations) {
                for (const node of Array.from(m.removedNodes)) {
                    const ElementCtor = globalThis.Element;
                    if (!ElementCtor || !(node instanceof ElementCtor))
                        continue;
                    if (stillInDom(node))
                        continue;
                    const stack = [node];
                    while (stack.length) {
                        const el = stack.pop();
                        if (stillInDom(el))
                            continue;
                        const set = this.registry.get(el);
                        if (set && set.size) {
                            // Итерируем по копии, чтобы безопасно модифицировать исходный set
                            for (const inst of Array.from(set)) {
                                try {
                                    inst.__reaperDestroy();
                                }
                                finally {
                                    set.delete(inst);
                                }
                            }
                            if (set.size === 0)
                                this.registry.delete(el);
                        }
                        for (let i = 0; i < el.children.length; i++) {
                            stack.push(el.children[i]);
                        }
                    }
                }
            }
        });
        const start = () => {
            this.observer.observe(document.body, { childList: true, subtree: true });
            document.removeEventListener('DOMContentLoaded', start);
        };
        if (document.body)
            start();
        else {
            document.addEventListener('DOMContentLoaded', start, { once: true });
        }
    }
    /** Регистрируем конкретный инстанс на элементе */
    static add(el, widget) {
        if (!(el instanceof HTMLElement))
            throw new Error('DomReaper.add: el must be HTMLElement');
        this.ensureObserver();
        let set = this.registry.get(el);
        if (!set) {
            set = new Set();
            this.registry.set(el, set);
        }
        set.add(widget);
    }
    /**
     * Снимает виджеты с указанного элемента.
     * @param el DOM-элемент
     * @param widget Если указан — снимается только этот инстанс.
     *               Если не указан — снимаются все виджеты на элементе.
     * @returns true, если удаление произошло; false, если нечего было удалять.
     */
    static remove(el, widget) {
        if (!(el instanceof HTMLElement))
            throw new Error('DomReaper.remove: el must be HTMLElement');
        const set = this.registry.get(el);
        if (!set)
            return false;
        if (widget) {
            if (!set.has(widget))
                return false;
            try {
                widget.__reaperDestroy();
            }
            finally {
                set.delete(widget);
                if (set.size === 0)
                    this.registry.delete(el);
            }
            return true;
        }
        else {
            for (const inst of Array.from(set)) {
                try {
                    inst.__reaperDestroy();
                }
                finally {
                    set.delete(inst);
                }
            }
            this.registry.delete(el);
            return true;
        }
    }
    static observeRoot(root) {
        this.ensureObserver();
        this.observer.observe(root, { childList: true, subtree: true });
    }
    static disconnect() {
        this.observer?.disconnect();
        this.observer = undefined;
        this.registry = new WeakMap();
    }
}
// Было: WeakMap<HTMLElement, Reapable>
DomReaper.registry = new WeakMap();

export { DomReaper };
